<template>
        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Serviços de enfermagem"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.servicosEnfermagem"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >
                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                            <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                            <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                            <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                            <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>

                                <template v-slot:cell(codigo)="row">
                                    <div v-if="row.item.procedimento.codigo">
                                        {{ row.item.procedimento.codigo | formatProcedimento }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>
</template>

<script>
// Filters.
import formats from '@/filters/formats'

export default {
    computed: {
        validations() {
            return {
                historico: { max: 300 },
            }
        },
    },
    filters: {
        ...formats,
    },
    data: () => ({
        fields: {
            table: [
                { key: 'info', label: '#', class: 'col-min text-nowrap' },
                { key: 'lotacao.ocupacao.codigo', label: 'CBO', class: 'col-min text-nowrap' },
                { key: 'lotacao.profissional.nome', label: 'Profissional', class: 'col-min' },
                { key: 'codigo', label: 'Código', class: 'col-min text-nowrap' },
                { key: 'procedimento.nome', label: 'Procedimento' },
                { key: 'observacoes', label: 'Observação' },
            ]
        },
    }),
    props: {
        data: { type: Object, required: true },
        readonly: { type: Boolean, default: false },
    },
}
</script>